export class MemberAuditRequest {
  accountId: string;
  transactionTypeCode: string;
  transactionSuccessInd: boolean;
  transactionErrorCode: string;
  additionalInfo: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/audit/memberAudit.model.ts